<template>
    <el-upload
        class="avatar-uploader"
        :http-request="changeFile"
        action=""
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
</template>

<script>
export default {
	props:{
		config:Object,
        value:String,
	},
    data() {
        return{
            prData:'',
            imageUrl:'',
        }
    }, 	
    watch:{
        'value'(){
            
            this.imageUrl = this.value
        },

    },
    methods: {
        changeFile () {     
            this.axios.post(window.file_upload_baseURL, this.prData).then(da=>{
                let {result,data,msg} = da.data;
                if(result!=0){
                    this.$message(msg)
                    return
                }

                this.imageUrl = data.url;
                this.$emit('input',this.imageUrl)
			}).catch(function (error) {
				console.log(error);
			});
        },
        getPr(fld){
            let app_secret = '1Q61s1iP8I376GyMTdsjOzd4hcLpZ4SG';
			let open_id = 7;
			let times = (Date.parse(new Date())/1000);
			let arr = [
				1003,
				app_secret,
				times,
				open_id
			];
            let formData = new FormData();
			formData.append("file", fld);
			formData.append('app_id', 1003);
			formData.append('sign', this.MD5(encodeURIComponent(arr.sort())))
			formData.append('user', open_id)
			formData.append('relation_type', 'activity')
			formData.append('timestamp', times)
            return formData
        },
		handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            let isJPG = true;
            let isLt2M = true;
            if(this.config.type){
                isJPG = this.config.type.indexOf(file.type)!=-1;
            }
            if(this.config.size){
                isLt2M = file.size / 1024 / 1024 <= this.config.size;
            }
            if (!isJPG) {
            this.$message.error('上传图片格式不正确 JPG|png 格式!');
            return isJPG
            }
            if (!isLt2M) {
            this.$message.error('上传图片大小不正确 10MB!');
            return isLt2M
            }
            this.prData = this.getPr(file)
            return isJPG && isLt2M;
        }
    }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>